import React from 'react'
import { FormattedMessage } from 'react-intl'

import { IDefinitionTable } from '../../shared/definition-table/DefinitionTable'

export const articleOneDefinitionsTable: IDefinitionTable[] = [
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowOne.title'
        defaultMessage='Besoins professionnels'
      />
    ),
    description: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowOne.description'
        defaultMessage='désigne les besoins de l’activité commerciale, industrielle, artisanale, libérale ou agricole du Client.'
      />
    ),
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowTwo.title'
        defaultMessage='CGU'
      />
    ),
    description: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowTwo.description'
        defaultMessage='désigne les présentes conditions générales d’utilisation du Site en ce compris son préambule et ses éventuelles annexes.'
      />
    ),
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowThree.title'
        defaultMessage='Client'
      />
    ),
    description: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowThree.description'
        defaultMessage='désigne la société cliente telle que visée en en-tête des présentes agissant en son nom et pour son compte en vue de commander des Prestations de Voyages d’affaires au bénéfice des Participants.'
      />
    ),
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowFour.title'
        defaultMessage='Compte'
      />
    ),
    description: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowFour.description'
        defaultMessage='désigne l’espace personnel créé sur le Site par le Client à l’aide des Identifiants et lui permettant d’effectuer des Demandes de réservation.'
      />
    ),
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowFive.title'
        defaultMessage='Contrat'
      />
    ),
    description: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowFive.description'
        defaultMessage='désigne la Convention avec les Contrats d’application conclus entre les Parties.'
      />
    ),
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowSix.title'
        defaultMessage='Contrat d’application'
      />
    ),
    description: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowSix.description'
        defaultMessage='désigne le devis signé par les Parties pour les Prestations de Voyages d’affaires, qui constitue la Proposition commerciale et indiquant les tarifs, les modalités de réservation, et de facturation du Service, ainsi que la proposition des Partenaires matérialisée par les conditions générales de prestation des Partenaires.'
      />
    ),
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowSeven.title'
        defaultMessage='Convention'
      />
    ),
    description: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowSeven.description'
        defaultMessage='désigne la présente convention générale pour les Voyages d’affaires et ses annexes conclue entre le Client et Naboo établissant les caractéristiques générales des Prestations de Voyages d’affaires devant être rendues par les Partenaires et dont les modalités seront précisées au sein des Contrats d’application pour les Prestations de Voyages d’affaires.'
      />
    ),
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowEight.title'
        defaultMessage='Demande de réservation'
      />
    ),
    description: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowEight.description'
        defaultMessage='désigne la demande du Client de réserver une Prestation de Voyages d’affaires auprès des Partenaires par l’intermédiaire de Naboo et dont les modalités restent à définir ou à confirmer entre les Parties.'
      />
    ),
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowNine.title'
        defaultMessage='Proposition commerciale'
      />
    ),
    description: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowNine.description'
        defaultMessage='désigne la proposition commerciale de Prestations de Voyages d’affaires qui est matérialisée par un devis adressé par Naboo au Client et qui une fois signé par le Client constitue le Contrat d’application de la Convention.'
      />
    ),
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowTen.title'
        defaultMessage='Frais de service'
      />
    ),
    description: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowTen.description'
        defaultMessage='Désigne les frais rémunérant le Service rendu par Naboo au Client.'
      />
    ),
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowEleven.title'
        defaultMessage='Identifiants'
      />
    ),
    description: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowEleven.description'
        defaultMessage='désigne l’adresse email et mot de passe choisi par le Client lui permettant de se connecter à son Compte.'
      />
    ),
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowTwelve.title'
        defaultMessage='Naboo'
      />
    ),
    description: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowTwelve.description'
        defaultMessage='désigne la société WOME STAY telle que visée en en-tête des présentes et proposant au Client des Prestations de Voyages d’affaires au nom et pour le compte des Partenaires grâce au Service.'
      />
    ),
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowThirteen.title'
        defaultMessage='Partenaire(s)'
      />
    ),
    description: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowThirteen.description'
        defaultMessage='désigne les partenaires au nom et pour le compte desquels Naboo propose et conclue les Contrats d’application encadrant les Prestations de Voyages d’affaires.'
      />
    ),
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowFourteen.title'
        defaultMessage='Participant(s)'
      />
    ),
    description: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowFourteen.description'
        defaultMessage='désigne le(s) personne(s) physique(s) participant au(x) Voyage(s) d’affaires, au bénéfice desquels les Partenaires exécutent lesdites Prestations de Voyages d’affaires au titre du Contrat conclu entre les Parties. Les Participants peuvent ainsi être notamment employés du Client.'
      />
    ),
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowFifteen.title'
        defaultMessage='Prestations de Voyages d’affaires'
      />
    ),
    description: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowFifteen.description'
        defaultMessage='désigne les prestations de Voyage d’affaires proposées au Client, à savoir l’hébergement, le service de restauration, les activités et le transport, étant précisé que le Client est libre de choisir l’une ou plusieurs de ces prestations.'
      />
    ),
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowSixteen.title'
        defaultMessage='Réservation'
      />
    ),
    description: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowSixteen.description'
        defaultMessage='désigne la commande d’une ou plusieurs Prestation(s) de Voyage d’affaires formalisée par un Contrat d’application.'
      />
    ),
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowSeventeen.title'
        defaultMessage='Service'
      />
    ),
    description: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowSeventeen.description'
        defaultMessage='désigne les Prestations de Voyages d’affaires proposées sur le Site par Naboo au nom et pour le compte des Partenaires.'
      />
    ),
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.articleOneDefinitionsTable.RowEighteen.title'
        defaultMessage='Site'
      />
    ),
    description: (
      <span>
        <FormattedMessage
          id='ui.TermsAndConditions.articleOneDefinitionsTable.RowEighteen.description'
          defaultMessage='désigne le site internet de Naboo figurant à l’adresse suivante : {siteUrl}'
          values={{
            siteUrl: (
              <a href='https://www.naboo.app/'>
                <FormattedMessage
                  id='ui.TermsAndConditions.articleOneDefinitionsTable.RowEighteen.link'
                  defaultMessage='https://www.naboo.app/'
                />
              </a>
            ),
          }}
        />
      </span>
    ),
  },
]
